import { snakeCase, camelCase } from 'lodash';

const snakeCaseKeys = (object: object): object =>
  Object.keys(object).reduce((snakeCasedObj, field) => {
    const fieldValue = object[field];
    const value = fieldValue && !Array.isArray(fieldValue) && typeof fieldValue === 'object' ? snakeCaseKeys(fieldValue) : fieldValue;

    return {
      ...snakeCasedObj,
      [snakeCase(field)]: value,
    }
  }, {})

const camelCaseKeys = (object: object): object =>
  Object.keys(object).reduce((camelCasedObj, field) => {
    const fieldValue = object[field];
    const value = fieldValue && !Array.isArray(fieldValue) && typeof fieldValue === 'object' ? camelCase(fieldValue) : fieldValue;

    return {
      ...camelCasedObj,
      [camelCase(field)]: value,
    }
  }, {})

export { snakeCaseKeys, camelCaseKeys };
